module.exports = __webpack_public_path__ + "static/img/RWB-52V2A_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWB-52V2A_1.png
// module id = JP5a
// module chunks = 0